import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const NavBar = () => {
  const [cookies, setCookies] = useCookies(["access_token"]);
  const navigate = useNavigate();

  // When logging out, deletes the access_token and userID from local storage
  const logOut = () => {
    setCookies("access_token", "");
    window.localStorage.removeItem("userID");
    navigate("/auth");
  };

  return (
    <nav className="navbar">
      <Link to="/"> Home</Link>
      {!cookies.access_token ? (
        <Link to="/auth"> Login/Register</Link>
      ) : (
        <>
          <Link to="/wishlist">Wishlist</Link>
          <Link to="/collection">Collection</Link>
          <button onClick={logOut}>Log Out</button>
        </>
      )}
    </nav>
  );
};
